export default __webpack_public_path__ + "static/media/profile_pic.9f76461a.svg";